import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Create an async thunk for fetching ItemsForSale
export const fetchSponsors = createAsyncThunk('sponsors/fetchSponsors', async () => {
  const response = await fetch('/api/sponsors');
  const data = await response.json();
  return data;
});

const sponsorsSlice = createSlice({
  name: 'sponsors',
  initialState: { sponsors: [], status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSponsors.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSponsors.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.sponsors = action.payload;
      })
      .addCase(fetchSponsors.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default sponsorsSlice.reducer;